// extracted by mini-css-extract-plugin
export default {"link":"PrimaryNavBar_link__k52rJ"};